<!-- Adapted from the design by Stephen Morley (http://code.stephenmorley.org) -->
@if (!readonly) {
  <span class="star-rating">
    @for (possibleRating of possibleRatings; track possibleRating) {
      <input required
        id="rating{{possibleRating}}"
        type="radio"
        [ngModel]="rating"
        (ngModelChange)="ratingChange.emit($event)"
        name="rating"
        [value]="possibleRating"
        title="{{possibleRating}} stars">
        <label for="rating{{possibleRating}}">{{possibleRating}}</label>
      }
    </span>
  }
  @if (readonly) {
    <span class="star-rating readonly-star">
      @for (possibleRating of possibleRatings; track possibleRating) {
        <input type="radio" title="{{rating}} stars" [checked]="rating === possibleRating">
        <label for="rating{{possibleRating}}">{{possibleRating}}</label>
      }
    </span>
  }
